import React, { useCallback, useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import { languageHelper } from "../../../../config/helperFunctions";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function ProfitLossReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: " ",
      accessorKey: "item",
    },
    {
      header: " ",
      accessorKey: "amount",
    },
  ];

  const [pageLoading, setPageLoading] = useState(true);
  const [data, setData] = useState([
    {
      item: "All Sales(Only Paid Amount)",
      amount: 0.0,
    },
    {
      item: "Subscriptions Amount with VAT",
      amount: 0.0,
    },
    {
      item: "Total Vat",
      amount: 0.0,
    },
    {
      item: "Customer Due Receive",
      amount: 0.0,
    },
    {
      item: "Purchase(Only Paid Amount)",
      amount: 0.0,
    },
    {
      item: "Expense",
      amount: 0.0,
    },
    {
      item: "Return",
      amount: 0.0,
    },
    {
      item: "Waste",
      amount: 0.0,
    },
    {
      item: "Supplier Due Payment",
      amount: 0.0,
    },
    {
      item: "Gross Profit = ((All Sales + Subscriptions + Customer Due Receive) - (Purchase + Expense + Return + Waste + Supplier Due Payment))",
      amount: 0.0,
    },
    {
      item: "Net Profit = ((All Sales + Subscriptions + Customer Due Receive) - (Purchase + Expense + Return + Waste + Supplier Due Payment) - Vat))",
      amount: 0.0,
    },
  ]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchData = useCallback(() => {
    setPageLoading(true);
    axios
      .get(`${apiKey}/api/rms/admin/profit-loss-report`, {
        params: {
          outletId: user?.user.outlet_id,
          from: startDate,
          to: endDate,
        },
      })
      .then((res) => {
        const data = res.data;
        setData([
          {
            item: languageHelper("All Sales(Only Paid Amount)"),
            amount: (Number(data.total_sales) || 0).toFixed(2),
          },
          {
            item: languageHelper("Subscriptions Amount with VAT"),
            amount: (Number(data.total_subscsription_amount) || 0).toFixed(2),
          },
          {
            item: languageHelper("Total Vat"),
            amount: (Number(data.total_vat) || 0).toFixed(2),
          },
          {
            item: languageHelper("Customer Due Receive"),
            amount: (Number(data.total_customer_due_amount) || 0).toFixed(2),
          },
          {
            item: languageHelper("Purchase(Only Paid Amount)"),
            amount: (Number(data.total_purchase) || 0).toFixed(2),
          },
          {
            item: languageHelper("Expense"),
            amount: (Number(data.total_expense) || 0).toFixed(2),
          },
          {
            item: languageHelper("Return"),
            amount: (Number(data.total_return) || 0).toFixed(2),
          },
          {
            item: languageHelper("Waste"),
            amount: (Number(data.total_waste) || 0).toFixed(2),
          },
          {
            item: languageHelper("Supplier Due Payment"),
            amount: (Number(data.total_supplier_due_payment) || 0).toFixed(2),
          },
          {
            item: languageHelper(
              "Gross Profit = ((All Sales + Subscriptions + Customer Due Receive) - (Purchase + Expense + Return + Waste + Supplier Due Payment))"
            ),
            amount: (Number(data.gross_profit) || 0).toFixed(2),
          },
          {
            item: languageHelper(
              "Net Profit = ((All Sales + Subscriptions + Customer Due Receive) - (Purchase + Expense + Return + Waste + Supplier Due Payment) - Vat))"
            ),
            amount: (Number(data.net_profit) || 0).toFixed(2),
          },
        ]);
      })
      .catch((err) => {})
      .finally(() => setPageLoading(false));
  }, [endDate, startDate, user?.user.outlet_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Profit Loss Report"}
        // buttonDataa={buttonDataa}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        downloads={true}
        noPagination={true}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
    </main>
  );
}

export default ProfitLossReport;
